import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';

const AlternateDashboard = () => {
  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>Alternate Dashboard</Text>
        <Text style={styles.subtitle}>A new experimental dashboard layout</Text>
      </View>

      <View style={styles.card}>
        <Text style={styles.cardText}>
          This is your alternate dashboard. Content will be added based on your next request.
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    gap: 24,
  },
  header: {
    gap: 4,
  },
  title: {
    fontSize: 24,
    fontWeight: '700',
    color: '#111827',
  },
  subtitle: {
    fontSize: 14,
    color: '#6b7280',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: 8,
    padding: 24,
    ...(Platform.OS === 'web' && {
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' as any,
    }),
  },
  cardText: {
    fontSize: 14,
    color: '#6b7280',
  },
});

export default AlternateDashboard;
